import { render, staticRenderFns } from "./DeviceStatus.vue?vue&type=template&id=c809aa7e&scoped=true&"
import script from "./DeviceStatus.vue?vue&type=script&lang=js&"
export * from "./DeviceStatus.vue?vue&type=script&lang=js&"
import style0 from "./DeviceStatus.vue?vue&type=style&index=0&id=c809aa7e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c809aa7e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c809aa7e')) {
      api.createRecord('c809aa7e', component.options)
    } else {
      api.reload('c809aa7e', component.options)
    }
    module.hot.accept("./DeviceStatus.vue?vue&type=template&id=c809aa7e&scoped=true&", function () {
      api.rerender('c809aa7e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/device/DeviceStatus.vue"
export default component.exports